import { createFileRoute } from '@tanstack/react-router';

import { RegisterForm } from '@/features/auth/RegisterForm';

/** `/register?redirect=` —— 註冊並直接登入。 */
export interface RegisterSearch {
  redirect?: string;
}

function validateRedirectSearch(search: Record<string, unknown>): RegisterSearch {
  // 只收字串；是否安全由 safeRedirect 在登入成功那一刻判斷（lib/auth/redirect.ts）。
  const redirect = search['redirect'];
  return typeof redirect === 'string' && redirect !== '' ? { redirect } : {};
}

export const Route = createFileRoute('/register')({
  validateSearch: validateRedirectSearch,
  component: RegisterRoute,
});

function RegisterRoute() {
  const { redirect } = Route.useSearch();
  return <RegisterForm redirect={redirect} />;
}
